import * as React from 'react';
import classnames from 'classnames';

type Props = {
  children: React.ReactNode,
  align?: 'center' | 'left',
  verticalAlign?: 'top' | 'center',
  minHeight?: number,
  narrowContent?: boolean,
  className?: string
};

class ModalFrameInner extends React.PureComponent<Props> {
  static defaultProps = {
    align: 'left',
    verticalAlign: 'top'
  };

  render() {
    const {
      align,
      verticalAlign,
      children,
      minHeight,
      narrowContent,
      className
    } = this.props;

    const customStyles: React.CSSProperties = {};

    if (minHeight) {
      customStyles.minHeight = `${String(minHeight)}px`;
    }

    const classes = classnames({
      'modal-frame-inner': true,
      [`modal-frame-inner--align-${String(align)}`]: align,
      [`modal-frame-inner--vertical-align-${String(verticalAlign)}`]: verticalAlign,
      'modal-frame-inner--narrow-content': narrowContent,
      [`${String(className)}`]: Boolean(className)
    });

    return (
      <div
        className={classes}
        style={customStyles}
      >
        {children}
      </div>
    );
  }
}

export default ModalFrameInner;
